/* Secondelle - modules de conversion : dates de livraison, copie du code, mini avis. */
(function () {
  'use strict';
  if (window.__sdPlus) return;
  window.__sdPlus = true;

  var DAYS = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
  var MONTHS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];

  function addBusinessDays(d, n) {
    var r = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; }
    return r;
  }
  function fmt(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }
  function fmtShort(d) { return d.getDate() + ' ' + MONTHS[d.getMonth()]; }

  /* Bloc livraison : se met a jour seul, y compris apres un rechargement du panier. */
  if (!customElements.get('sdp-delivery')) {
    customElements.define('sdp-delivery', class extends HTMLElement {
      connectedCallback() { this.tick(); this._t = setInterval(this.tick.bind(this), 30000); }
      disconnectedCallback() { clearInterval(this._t); }
      tick() {
        var now = new Date();
        var ship = addBusinessDays(now, parseInt(this.dataset.ship, 10) || 2);
        var a = addBusinessDays(ship, parseInt(this.dataset.min, 10) || 5);
        var b = addBusinessDays(ship, parseInt(this.dataset.max, 10) || 15);
        var tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
        var shipIfTomorrow = addBusinessDays(tomorrow, parseInt(this.dataset.ship, 10) || 2);
        var lead = this.querySelector('[data-sdp-lead]');
        if (lead) {
          if (shipIfTomorrow.getTime() !== ship.getTime()) {
            var mins = Math.max(1, Math.round((tomorrow - now) / 60000));
            var h = Math.floor(mins / 60), m = mins % 60;
            var left = (h ? h + ' h ' : '') + (h && m < 10 ? '0' : '') + m + ' min';
            lead.innerHTML = 'Commandez dans les <strong>' + left + '</strong> : expédition au plus tard le <strong>' + fmt(ship) + '</strong>';
          } else {
            lead.innerHTML = 'Commandez aujourd’hui : expédition au plus tard le <strong>' + fmt(ship) + '</strong>';
          }
        }
        var s = this.querySelector('[data-sdp-d="ship"]'); if (s) s.textContent = 'D’ici le ' + fmtShort(ship);
        var r = this.querySelector('[data-sdp-d="range"]'); if (r) r.textContent = 'Entre le ' + fmtShort(a) + ' et le ' + fmtShort(b);
      }
    });
  }

  /* Copier le code de bienvenue */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sdp-copy]');
    if (!b) return;
    var code = b.getAttribute('data-sdp-copy');
    function ok() { b.textContent = 'Copié ✓'; b.classList.add('is-ok'); setTimeout(function () { b.textContent = 'Copier'; b.classList.remove('is-ok'); }, 2500); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, ok); else ok();
  });

  /* Mini avis : defilement automatique toutes les 5 s, fleches */
  function initQuotes() {
    document.querySelectorAll('[data-sdp-quotes]').forEach(function (box) {
      if (box.__sdp) return; box.__sdp = true;
      var items = box.querySelectorAll('.sdp-quote'), i = 0, timer;
      if (items.length < 2) return;
      function go(n) { items[i].classList.remove('is-on'); i = (i + n + items.length) % items.length; items[i].classList.add('is-on'); }
      function auto() { clearInterval(timer); if (!matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(function () { go(1); }, 5000); }
      box.addEventListener('click', function (e) { var n = e.target.closest('[data-sdp-q]'); if (n) { go(parseInt(n.getAttribute('data-sdp-q'), 10)); auto(); } });
      box.addEventListener('mouseenter', function () { clearInterval(timer); });
      box.addEventListener('mouseleave', auto);
      auto();
    });
  }
  /* Bouton du panier : « Commander · 41,22 € » */
  function totals() {
    document.querySelectorAll('.cart__checkout-button').forEach(function (btn) {
      var box = btn.closest('.cart-drawer__summary, .cart-summary, form, body');
      var t = box && box.querySelector('[data-cart-subtotal]');
      var val = t && (t.getAttribute('value') || t.textContent || '').trim();
      var txt = btn.querySelector('.button-text');
      if (!val || !txt) return;
      var span = txt.querySelector('.sdp-total');
      if (!span) { span = document.createElement('span'); span.className = 'sdp-total'; txt.appendChild(span); }
      if (span.textContent !== '· ' + val) span.textContent = '· ' + val;
    });
  }
  function boot() {
    initQuotes(); totals();
    new MutationObserver(function () { initQuotes(); totals(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
